/*
 * 大仓公共请求库
 * @Author: easonlchen
 * @Date: 2021-10-14 17:15:54
 * @LastEditors: easonlchen
 * @LastEditTime: 2021-11-14 22:05:56
 */

import HttpClassBaseClass, { api } from './request/request';

export const API = api;
export const HttpClassBase = HttpClassBaseClass;
